import {
  useRealtimeKitMeeting,
  useRealtimeKitSelector,
} from "@cloudflare/realtimekit-react";
import { RtkMeeting } from "@cloudflare/realtimekit-react-ui";
import React, { useEffect } from "react";
import { useRouterStore } from "../../Stores/Router";
import "./VideoCall.scss";
import {
  elementConfig,
  meetingStyles,
  notificationConfig,
} from "./MeetingConfig";
import CommunicationManager from "../../Helper/CommunicationManager";
import { stopLocalTracks } from "./stopLocalTracks";

const VideoCall = () => {
  const { setOpenVideoCall } = useRouterStore();
  const { meeting } = useRealtimeKitMeeting();
  const roomState = useRealtimeKitSelector((m) => m.self.roomState);

  // Notify the host page and toggle the call UI on room-state changes.
  // Do NOT stop local tracks in this effect: its cleanup runs on every
  // roomState change (e.g. init -> joined), and stopping the tracks there
  // kills the camera/mic RealtimeKit just acquired (they end up readyState
  // "ended" and never produce). Track teardown happens on unmount (below)
  // and on explicit leave (CustomControlBar.leaveCall / rtk-leave-button).
  useEffect(() => {
    if (roomState === "joined" || roomState === "init") {
      CommunicationManager.getInstance().sendMessage({
        name: "video-call-joined",
      });
      setOpenVideoCall(true);
    } else {
      CommunicationManager.getInstance().sendMessage({
        name: "video-call-left",
      });
      setOpenVideoCall(false);
    }
  }, [roomState]);

  // Release the camera/mic hardware when the call view is torn down.
  // RealtimeKit's leave() doesn't reliably stop local tracks with persistent
  // permissions, so we stop them ourselves here. This runs only on unmount,
  // never on roomState transitions, so it can't kill an in-progress join.
  useEffect(() => {
    return () => {
      CommunicationManager.getInstance().sendMessage({
        name: "video-call-left",
      });
      setOpenVideoCall(false);
      stopLocalTracks(meeting);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RtkMeeting
      showSetupScreen={false}
      meeting={meeting}
      config={{
        designTokens: {
          spacingBase: 4,
          googleFont: "Inter",
        },
        styles: meetingStyles,
        root: {
          ...(elementConfig as any),
          "div#controlbar-mobile": [
            "rtk-fullscreen-toggle",
            "rtk-screen-share-toggle",
            "rtk-mic-toggle",
            "rtk-camera-toggle",
            "rtk-webinar-stage-toggle",
            "rtk-stage-toggle",
            "rtk-leave-button",
            "rtk-more-toggle",
          ],
          "div#controlbar-left": [
            "rtk-fullscreen-toggle",
            "rtk-screen-share-toggle",
            "rtk-livestream-toggle",
          ],
          "div#controlbar-right": ["rtk-chat-toggle", "rtk-settings-toggle"],
        },
        config: notificationConfig,
      }}
    />
  );
};

export default VideoCall;
